<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style scoped>
.ql-container.ql-snow {
  min-height: 100px;
}
.profile-edit .ql-editor {
  min-height: 100px;
}
</style>
<template>
  <div id="page-attendee-add">
    <vx-card v-if="EventData && !EventCreated">
      <div slot="no-body" class="tabs-container px-6 pt-2">
        <div class="vx-row">
          <!-- <div class="vx-col md:w-1/1 w-full mb-4 text-center">            
            <h3>Event Info</h3>
          </div> -->
          <div class="vx-col sm:w-1/2 w-full md:mt-2 name-evnt">
            <label>Event Name*</label>
            <vs-input
              class="w-full"
              v-validate="'required'"
              name="Event Name"
              v-model="EventData.EventFullName"
            />
            <!-- <div class="custom-head-wrap"> -->
              <!-- <input
                type="text"
                name="Event Name"           
                v-model="EventData.EventFullName"
                v-validate="'required'"
                class="w-full" id="" value="" placeholder="Event Name*"/>
          </div> -->
            <span
              class="text-danger text-sm"
              v-show="errors.has('Event Name')"
              >{{ errors.first("Event Name") }}</span
            >
          </div>
          <!-- <div class="vx-col sm:w-1/2 w-full md:mt-2 name-evnt">
            <vs-input
              class="w-full"
              label="Event Slug"
              v-validate="'alpha_dash'"
              name="Event Slug"
              v-model="EventData.EventSlug"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Event Slug')"
              >{{ errors.first("Event Slug") }}</span
            >
          </div> -->
          <div class="vx-col sm:w-1/2 w-full mb-2 mt-3">
            <label>Event Type</label>
            <v-select
              class="w-full select-large"
              label="Name"
              v-model="EventData.LocationType"
              :options="locationOptions"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2 mt-2" v-if="EventData.LocationType.Name != 'Virtual'">
            <label>Venue</label>
            <vs-input
              v-show="EventData.LocationType.Name != 'Virtual'"
              class="w-full"
              v-model="EventData.Venue"
            />
          </div>
          <div class="vx-col sm:w-6/12 w-full mt-4">
            <label>Time Zone</label>
            <vs-select
              v-model="EventData.TimeZone"
              class="w-full select-large"
              :options="tzStrings"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in tzStrings"
                class="w-full"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/2 w-full md:mt-4">
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full evnt-date">
                <label class="type-evnt-lbl">Event Start Date</label>
                <flat-pickr
                  :config="configdateTimePickerStart"
                  class="time-pkr"
                  placeholder="Start Date"
                  v-validate="'required'"
                  name="Event Start Date"
                  v-model="EventData.EventStartDate"
                ></flat-pickr>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Event Start Date')"
                  >{{ errors.first("Event Start Date") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/2 w-full evnt-date">
                <label class="type-evnt-lbl">Event End Date</label>
                <flat-pickr
                  :config="configdateTimePickerEnd"
                  class="time-pkr"
                  placeholder="End Date"
                  v-validate="'required'"
                  name="Event End Date"
                  v-model="EventData.EventEndDate"
                ></flat-pickr>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Event End Date')"
                  >{{ errors.first("Event End Date") }}</span
                >
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-6/12 w-full mt-4">
            <label>
              <span>Login Authentication</span>
            </label>
            <div class="w-full mt-2">
              <v-select
                class="w-full select-large"
                v-model="EventData.EventAccessType"
                :options="[
                  'Unique Passcode per Attendee',
                  'Use Common Event Passcode',
                ]"
              />
            </div>
          </div>

          <div
            class="vx-col sm:w-6/12 w-full mt-4"
            v-show="EventData.EventAccessType == 'Use Common Event Passcode'"
          >
            <div class="w-full mt-2">
              <label>Default Passcode</label>
              <vs-input
                name="Default Passcode"
                class="w-full"
                v-model="EventData.defaultEP"
                v-validate="
                  EventData.EventAccessType == 'Use Common Event Passcode'
                    ? 'required'
                    : ''
                "
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Default Passcode')"
                >{{ errors.first("Default Passcode") }}</span
              >
            </div>
          </div>

          <!-- <div class="vx-col sm:w-1/2 w-full mt-4">
            <label>Default Event Language</label>
            <div class="w-full">
              <div class="w-full">
                <v-select
                  class="mt-2"
                  :options="['Engilsh', 'German', 'French', 'Mandarin']"
                  v-model="defaultLanguage"
                />
              </div> -->
              <!-- <vs-radio
                v-model="EventData.StreamingClient"
                vs-value="Web"
                name="StreamingClient"
                >Web</vs-radio
              >
              <vs-radio
                class="ml-3"
                v-model="EventData.StreamingClient"
                vs-value="Zoom"
                name="StreamingClient"
                >Zoom</vs-radio
              > -->
            <!-- </div>
          </div> -->

          <div class="vx-col sm:w-3/12 w-full mt-4">
            <label class="type-evnt-lbl w-full labl-head">
                <span>Event Access Type</span>
                <span class="event-access-info">
                <feather-icon class="ml-2" icon="InfoIcon" title />
                <div class="event-type-head-tooltip-event-create">
                    <p class="mb-0">
                    <strong>Public:</strong>
                    </p>
                    <p>
                    Anyone can discover and register for a Public event (they will
                    be indexed by search engines).
                    </p>
                    <p class="mb-0">
                    <strong>Private:</strong>
                    </p>
                    <p>
                    Events which do not require self registration. Event planners
                    send invitation and login info to join the event.
                    </p>
                </div>
                </span>
            </label>
            <div class="w-full mt-2">
                <vs-radio color="#4c8bf6" v-model="EventData.EventType" vs-value="2"
                >Public</vs-radio
                >
                <vs-radio color="#4c8bf6" class="ml-3" v-model="EventData.EventType" vs-value="1"
                >Private</vs-radio
                >
            </div>
        </div>
        <div
        class="vx-col sm:w-3/12 w-full mt-5"
        v-if="EventData.EventType == 2"       
        >
            <div class="type-evnt-create">
                <!--<label class="type-evnt-lbl">Allow Registration</label>-->
                <div class="w-full mt-2">
                <vs-checkbox v-model="EventData.AllowRegistration"
                    >Allow Registration</vs-checkbox
                >
                </div>
            </div>
        </div>

          <!-- <div
            class="vx-col sm:w-3/12 w-full mt-4"
            v-show="ClientDetails && ClientDetails.crm_integration && ClientDetails.crm_integration.IsPublished"
          >
            <label>CRM Integration</label>
            <vs-switch
              class="mt-4"
              @change="checkCRMDisable"
              v-model="EventData.postToCRM"
            />
          </div> -->
          
          <div class="vx-col sm:w-6/12 w-full mt-4">
            <label>Default Streaming Client</label>
            <div class="w-full mt-2">
              <vs-radio
                v-model="EventData.StreamingClient"
                vs-value="Web"
                name="StreamingClient"
                >Web</vs-radio
              >
              <vs-radio
                class="ml-3"
                v-model="EventData.StreamingClient"
                vs-value="Zoom"
                name="StreamingClient"
                >Zoom Client</vs-radio
              >
              <vs-radio
                class="ml-3"
                v-model="EventData.StreamingClient"
                vs-value="ZoomWeb"
                name="StreamingClient"
                >Zoom Web</vs-radio
              >
            </div>
          </div>

          <div class="vx-col md:w-1/2 w-full mt-2" v-if="EventData.StreamingClient.includes('Zoom')">
            <label>Approval Type</label>
              <v-select
                class="mt-3"
                label="Name"
                :clearable="false"
                :options="[
                  {Name:'Open Meeting', id:2},
                  //{Name:'Need Approval', id:1},
                  {Name:'Need Registration', id:0}
                ]"
                :reduce="(option) => option.id"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="EventData.approval_type"
              />
          </div>
          

          <div class="vx-col md:w-1/1 w-full mt-8 position-relative hidden">
            <label>Description</label>
            <div class="mail-tmplt-btns">
              <div class="tmplt-btn-wrap">
                <a
                  class="right-off-radius"
                  @click="showRawHtml = showRawHtml ? false : true"
                  >{{ showRawHtml ? "Editor" : "HTML Code" }}</a
                >
              </div>
            </div>
            <div class="profile-edit">
              <ckeditor class="desc-event" v-if="!showRawHtml" v-model="EventData.Description" :config="editorConfig"></ckeditor>
              <vs-textarea
                v-if="showRawHtml"
                v-model="EventData.Description"
                class="inputx w-full"
                rows="10"
                cols="100"
              />
            </div>
          </div>
        </div>

        <div class="vx-row hidden">          
          <div class="vx-col sm:w-1/2 w-full mb-2 mt-3">
            <label>Default Landing Page</label>
            <v-select
              class="w-full select-large"
              v-model="EventData.DefaultLandingURL"
              :options="landingURLOptions"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2 name-evnt mt-3 d-none">
            <vs-input
              v-show="EventData.LocationType.Name != 'Virtual'"
              class="w-full"
              label="Location"
              v-model="EventData.Venue"
            />
          </div>
        </div>

        <!-- <div class="vx-row hidden">
          <div class="vx-col md:w-1/1 w-full mt-8">
            
            <div class="custome-heading"><h3>Apply Theme</h3></div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-3 text-center">
            <div class="default-theme-wrapper">
              <div class="radio-wrapper">
                <vs-radio
                  v-model="BrandingJson.appColorHexCodeType"
                  vs-value="headerColorsHexCodeLight"
                  >Default</vs-radio
                >
                <div class="theme-info-area">
                  <feather-icon
                    class="ml-2 info-ico-i"
                    icon="InfoIcon"
                    title
                  />
                  <div class="theme-thumbnail-tooltip">
                    <div class="thumb-image-wrapper">
                      <img src="../../assets/images/default-theme.jpg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-3 text-center">
            <div class="default-theme-wrapper dark-theme-wrapper">
              <div class="radio-wrapper">
                <vs-radio
                  class="ml-3"
                  v-model="BrandingJson.appColorHexCodeType"
                  vs-value="headerColorsHexCodeDark"
                  >Dark</vs-radio
                >
                <div class="theme-info-area">
                  <feather-icon
                    class="ml-2 info-ico-i"
                    icon="InfoIcon"
                    title
                  />
                  <div class="theme-thumbnail-tooltip">
                    <div class="thumb-image-wrapper">
                      <img src="../../assets/images/dark-theme.jpg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-3 text-center">
            <div class="w-full">
              <vs-checkbox v-model="BrandingJson.uploadCustomLogoAndBanner"
                >Upload Custom Logo &amp; Banner</vs-checkbox
              >
            </div>
          </div>
        </div>         

        <div class="vx-row hidden" v-show="BrandingJson.uploadCustomLogoAndBanner == true">
          <div class="vx-col md:w-1/2 w-full mt-8 banner-single-wrap">
            <h4>Upload Logo</h4>
            <div class="event-icon-upload banner-wrap mt-4">
              <div class="logo-wrap-hld single-banner" style="height: 84px">
                <img
                  v-if="BrandingJson['eventLogo']['960x192']"
                  :src="BrandingJson['eventLogo']['960x192']"
                />
                <span class="img-delete-butn" v-if="BrandingJson['eventLogo']['960x192']">
                  <button
                    @click="
                      deleteBrandingJson($event, '960x192', 'eventLogo')
                    "
                  >
                    <img src="../../assets/images/btn-del.png" />
                  </button>
                </span>
              </div>
              <div class="choose-file-area">
                <input
                  type="file"
                  @change="uploadBrandingJson($event, '960x192', 'eventLogo')"
                  accept="image/*"
                />
                <div class="image-specification">
                  <p>
                    <strong>Image Specification</strong>
                  </p>
                  <p>
                    Supported image formats: jpeg, png and recommended image
                    dimension 960/192
                  </p>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <h4>Upload Banner</h4>
              <div class="event-icon-upload banner-wrap mt-4">
                <div class="logo-wrap-hld single-banner" style="height: 84px">
                  <img
                    v-if="BrandingJson['banner']['2048x88']"
                    :src="BrandingJson['banner']['2048x88']"
                  />
                  <span class="img-delete-butn" v-if="BrandingJson['banner']['2048x88']">
                    <button
                      @click="deleteBrandingJson($event, '2048x88', 'banner')"
                    >
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>

                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJson($event, '2048x88', 'banner')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>
                      Supported image formats: jpeg, png and recommended image
                      dimension 2048/88
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-col md:w-1/2 w-full mt-8">
            <h4 class="choose-color-head">Background</h4>
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <div class="single-color-bar">
                  <label style="width: 100%">Background Color</label>
                  <input v-model="EventData.BackgroundColor" type="color" />
                </div>
              </div>
              <div class="vx-col md:w-1/2">
                <div class="single-color-bar">
                  <label style="width: 100%">Body Text Color</label>
                  <input v-model="EventData.BodyTextColor" type="color" />
                </div>
              </div>
            </div>

            <label>Or choose a background image</label>
            <div class="event-icon-upload banner-wrap">
              <div
                class="logo-wrap-hld single-banner back-image-banner"
                style="height: 250px"
              >
                <img
                  v-if="BrandingJson['eventBGImage']['2732x2048']"
                  :src="BrandingJson['eventBGImage']['2732x2048']"
                />
                <span class="img-delete-butn" v-if="BrandingJson['eventBGImage']['2732x2048']">
                  <button
                    @click="
                      deleteBrandingJson($event, '2732x2048', 'eventBGImage')
                    "
                  >
                    <img src="../../assets/images/btn-del.png" />
                  </button>
                </span>
              </div>
              <div class="choose-file-area">
                <input
                  type="file"
                  @change="
                    uploadBrandingJson($event, '2732x2048', 'eventBGImage')
                  "
                  accept="image/*"
                />
                <div class="image-specification">
                  <p>
                    <strong>Image Specification</strong>
                  </p>
                  <p>
                    Supported image formats: jpeg, png and recommended image
                    dimension 2732/2048
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row hidden">
          <div class="vx-col md:w-1/1 w-full mt-3">
           
            <div class="custome-heading"><h3>Hosted By</h3></div>
          </div>
          <div class="vx-col md:w-1/1 w-full">
            <div class="host-section">
              <div class="vx-row">
                
                <div class="vx-col md:w-6/12 w-full">
                  <div class="host-name">
                    <label>Host Name</label>
                    <vs-input
                      v-model="BrandingJson.HostInfo.Name"
                      class="inputx mt-2 w-full"
                    />
                  </div>

                  <div class="host-desc mt-5">
                    <label>Host Short profile</label>
                    <vs-textarea
                      v-model="BrandingJson.HostInfo.Profile"
                      class="host-description-box mt-2"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-6/12 w-full border-right-1">
                  <div class="host-logo">
                    <div class="host-logo-wrap">
                      <img
                        v-if="BrandingJson['HostInfo']['Logo']"
                        :src="BrandingJson['HostInfo']['Logo']"
                      />
                      <input
                        id="fuHostLogo"
                        type="file"
                        @change="
                          uploadBrandingJson($event, 'Logo', 'HostInfo')
                        "
                        accept="image/*"
                        ref="fuHostLogo"
                        style="display: none"
                      />
                    </div>
                    <div class="logo-edit-butn">
                      <vs-button
                        color="primary"
                        type="filled"
                        v-on:click="$refs.fuHostLogo.click()"
                      >
                        <feather-icon icon="EditIcon" />
                      </vs-button>
                    </div>
                  </div>
                  <div style="text-align: center; padding-top: 5px">
                    Dimension 960x192px (JPEG/PNG)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        
        <div class="vx-row mt-4">
          <div class="vx-col md:w-1/1 w-full">
            <div class="custome-heading">
              <h3>What would you like the event to have?</h3>
            </div>
          </div>
          <div class="vx-col sm:w-4/12 w-full mt-5" v-for="listItem in Features" :key="listItem.ID">
            <div
              class="box-wrap"
              :class="listItem.selected ? 'active-menu-box' : ''"
            >
              <vs-checkbox
                :disabled="listItem.IsDefault"
                v-model="listItem.selected"
                :value="listItem"
                >{{ listItem.Name }}</vs-checkbox
              >
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 mb-8 flex flex-wrap items-center justify-end">      
              <vs-button type="border" color="warning" @click="continueEventList">Cancel</vs-button>        
              <vs-button 
                class="ml-2 ml-auto"
                color="success"
                @click="before_save"
              >Create Event</vs-button>   
            </div>
          </div>
        </div>

      </div>
    </vx-card>


    <div class="vx-row mb-5 success-confetti" v-if="EventCreated">
      <div class="text-center w-full success-class">
        <span><img src="../../assets/images/check-success.svg"/></span>
        <h2>Your event has been</h2>
        <h2 class="mb-3">successfully created!</h2>
        <h5>Select Design Theme, Event features and modules.</h5>        
      </div>
      <div class="text-center w-full">
        <vs-button  color="rgb(76, 139, 246)" type="filled" @click="continueEventEdit">Save and Continue</vs-button>
      </div>
    </div>


  </div>
</template>



<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
//import moment from 'vue-moment'
import moment from "moment-timezone";
import draggable from "vuedraggable";
import CKEditor from 'ckeditor4-vue';
import CKconfig from "@/assets/ckeditor-config.ts";

import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";

import ls from "@/common/localStorage";
import tzList from "@/assets/TimeZoneList.ts"
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
var vm;
export default {
  data() {
    return {
      editorConfig: CKconfig.editorConfig,
      popupActive: false,
      EventCreated: false,
      center: { lat: 10.0, lng: 10.0 },
      markers: [
        { position: { lat: 10.0, lng: 10.0 } },
        { position: { lat: 11.0, lng: 11.0 } },
      ],
      locationOptions: [
        { Id: 1, Name: "In-person" },
        { Id: 2, Name: "Virtual" },
        { Id: 3, Name: "Hybrid" },
      ],
      statusOptions: [
        { text: "Plannning", value: "plannning" },
        { text: "In Progress", value: "in progress" },
        { text: "Finished", value: "finished" },
      ],
      LocationOptions: [
        { text: "New York", value: "new-york" },
        { text: "Chicago", value: "chicago" },
        { text: "San Francisco", value: "san-francisco" },
        { text: "Boston", value: "boston" },
      ],
      landingURLOptions: [
        "/lobby",
        "/sessions",
        "/livestage",
        "/stageview",
        "/attendee",
        "/exhibitorshall",
        "/mymeetings",
        "/myprofile",
      ],

      list: [],
      Features: [],
      showRawHtml: false,
      configdateTimePickerStart: {
        minDate: new Date(),
        onChange: function (val) {
          if (val) {
            vm.configdateTimePickerEnd.minDate = new Date(val);
          }
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 0,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerEnd: {
        minDate: new Date().setHours(0, 0, 0, 0),
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 0,
        defaultMinute: 0,
        time_24hr: false,
      },
      popupActiveEvnetAddSuccess: false,
      EventId: "",
      EventData: null,
      tzStrings: tzList,
      ClientDetails: null,
      defaultLanguage: "English",
      Event_info: null,
      BrandingJson: {
        eventLogo: { "960x192": "", "600x600": "" },
        eventBGImage: { "2048x2732": "", "2732x2048": "" },
        banner: {
          "640x88": "",
          "750x103": "",
          "1125x156": "",
          "1242x171": "",
          "1440x176": "",
          "2732x88": "",
          "2048x88": "",
        },
        splashScreenImages: {
          "1125x2436": "",
          "1440x2560": "",
          "2048x2732": "",
          "2732x2048": "",
        },
        headerColorsHexCode: {
          topBar: "#FFFFFF",
          headerBar: "#FFFFFF",
          fontBar: "#000000",
          sideNavigationAndIconColor: "#64656E",
        },
        appColorHexCodeType: "headerColorsHexCodeLight",
        uploadCustomLogoAndBanner: false,
        headerColorsHexCodeLight: {
          cardBackground: "#ffffff",
          iconBackground: "#35393d",
          fontColorHeader: "#000000",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#ffffff",
          tabSelectionColor: "#000000",
        },
        headerColorsHexCodeDark: {
          cardBackground: "#15191c",
          iconBackground: "#35393d",
          fontColorHeader: "#ffffff",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#272d30",
          tabSelectionColor: "#ffffff",
        },
        headerColorsHexCodeCustom: {
          cardBackground: "#ffffff",
          iconBackground: "#35393d",
          fontColorHeader: "#000000",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#ffffff",
          tabSelectionColor: "#000000",
        },
        HostInfo: {
          Name: "",
          Profile: "",
          Logo: "",
        },
      },
    };
  },
  methods: {
    checkCRMDisable() {
      if (this.EventData.postToCRM === false) {
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Are you Sure?",
          text: "This will stop sending Registration data to your CRM",
          acceptText: "OK",
        });
      }
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          //resolve(result);
          if (result) {
            resolve(vm.formSubmitted());
          }
        });
      });
    },
    uploadBrandingJson(input, filename, filesrc) {
      //alert("uploadBrandingJson:" + filename);
      //console.log(filename + filesrc)
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        input.target.value = "";
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        debugger;
        let dimension = [];
        if (filesrc.toLowerCase() === "hostinfo") {
          dimension = [960, 192];
        } else {
          dimension = filename.split("x");
        }
        //let dimension = filename.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width == dimension[0] && this.height == dimension[1]) {
            vm.uploadFile(file, filename, filesrc);
          } else {
            alert("File dimension does not match " + filename);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadFile(file, filename, filesrc) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.BrandingJson[filesrc][filename] = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    formSubmitted() {
      this.EventData.StartDateTZ = moment(this.EventData.EventStartDate).format(
        "MMM DD, YYYY"
      );
      this.EventData.StartTimeTZ = moment(this.EventData.EventStartDate).format(
        "HH:mm"
      );
      this.EventData.EndDateTZ = moment(this.EventData.EventEndDate).format(
        "MMM DD, YYYY"
      );
      this.EventData.EndTimeTZ = moment(this.EventData.EventEndDate).format(
        "HH:mm"
      );
      this.EventData.StartDate = this.GetTimeByZone(
        this.EventData.EventStartDate,
        this.EventData.TimeZone
      );
      this.EventData.EndDate = this.GetTimeByZone(
        this.EventData.EventEndDate,
        this.EventData.TimeZone
      );
      this.EventData.DefaultLanguage = this.defaultLanguage;
      this.$vs.loading();
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("eventManagement/addEventAPI", { 
            data: this.EventData,
            SelectedFeatures: this.Features,
            //BrandingJson: this.BrandingJson 
            })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              title: "Event",
              text: res.message,
            });
            this.$vs.loading.close();
            if (res.status == 200) {   
              let info = {
                Session_Event_Id: res.data.EventId,
                Session_Event_CollectionName: res.data.EventCollectionName,
                Session_Event_FullName: res.data.EventFullName,
                Session_Event_TZ: res.data.TimeZone,
                Sesion_StreamingClient: res.data.StreamingClient,
                Sesion_ApprovalType: res.data.approval_type,
                Default_Event_Language: res.data.DefaultLanguage,
                Session_LocationType: res.data.LocationType.Name
              };
              this.Event_info = info;
              //ls.setSessionUserInfo(info);
              //this.$emit("closeEventAddPopup");
              //this.popupActiveEvnetAdd = false;
              //this.popupActiveEvnetAddSuccess = true;
              //location.href = "/event/edit";
              //this.$router.push('/event/list');
              this.EventCreated = true;
              this.EventData = null;
              this.fetch_event_data();
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Event",
                text: "Event Not Created",
              });
            }
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Event",
              text: "Something Went Wrong!",
            });
          });
      });
      //this.popupActiveEvnetAddSuccess = true;
    },
    deleteBrandingJson(input, filename, filesrc) {
      this.BrandingJson[filesrc][filename] = "";
    },
    continueEventList(){
      this.$emit("fetchEvents");
      this.$emit("closeEventAddPopup");
    },
    continueEventEdit() {
      this.$store.dispatch("eventManagement/getUserEvents").then((res) => {
        ls.setSessionUserInfo(vm.Event_info);
        location.href = "/event/edit/#apply_theme";
      });
      
    },
    fetch_event_data() {
      this.$store
        .dispatch("eventManagement/fetchEvent", null)
        .then((res) => {
          this.EventData = res.data;
          this.EventData.EventStartDate = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(8,0,0);
          this.EventData.EventEndDate = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(18,0,0);
        })
        this.$store
        .dispatch("eventManagement/fetchClientFeatures")
        .then((res) => {
          this.Features = res.AllFeatures ? res.AllFeatures : [];
        });
    },
    fetchClient() {
      this.$store
        .dispatch("clientManagement/fetchClient", Session_Client_Id)
        .then((res) => {
          if (res.status == 200) {
            this.ClientDetails = res.data;
            this.EventData.postToCRM = this.ClientDetails.crm_integration
              .IsPublished
              ? true
              : false;
            if(this.ClientDetails.clientSettings && this.ClientDetails.clientSettings.StreamingClient)
              this.EventData.StreamingClient = this.ClientDetails.clientSettings.StreamingClient;
            if(this.ClientDetails.clientSettings && this.ClientDetails.clientSettings.approval_type != undefined)
              this.EventData.approval_type = this.ClientDetails.clientSettings.approval_type;
          }
        });
    },
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    flatPickr,
    draggable,
    vSelect,
    quillEditor,
    ckeditor: CKEditor.component
  },

  mounted() {
    vm = this;
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.fetch_event_data();
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetchClient();
  },
  watch: {
    "EventData.EventType"(val) {
      if (val == 1) {
        this.EventData.AllowRegistration = false;
      }
    },
    "EventData.EventFullName"(val){
      this.EventData.EventSlug = val.toLowerCase().replace(/[ ]/g, "_").replace(/[^a-z\d_-]/g, "")
    }
  },
};
</script>